import { render, staticRenderFns } from "./wedding.vue?vue&type=template&id=e85c1cba&scoped=true&"
import script from "./wedding.vue?vue&type=script&lang=js&"
export * from "./wedding.vue?vue&type=script&lang=js&"
import style0 from "./wedding.vue?vue&type=style&index=0&id=e85c1cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85c1cba",
  null
  
)

export default component.exports